const btnHamburger = document.getElementById('hamburger-btn')
const menu = document.getElementById('mobil-menu')

btnHamburger.addEventListener('click', navToggle)

// Toggle Mobile Menu
function navToggle() {
    btnHamburger.classList.toggle('open')         // jenom pro animaci linek
    btnHamburger.addEventListener('click', () => {      // při kliknutí na menu btn screen vyjede nahoru
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    });
    menu.classList.toggle('flex')
    menu.classList.toggle('ukazat')
}


// MEGA MENU
// pokud chceme megamenu, vložíme do CSS Classes v adminu 'mega-services' nebo 'mega-reference'
// pokud chceme u menu item šipku, vložíme do CSS Classes v adminu 'drop-down-sipka'

const referenceItem = document.querySelector('.mega-reference');
const serviceItem = document.querySelector('.mega-services');
const megaMenuReference = document.getElementById('mega-menu-reference');
const megaMenuServices = document.getElementById('mega-menu-services');

function showReference() {
    megaMenuReference.classList.remove("hidden");
}

function hideReference() {
    megaMenuReference.classList.add("hidden");
}

referenceItem.addEventListener('mouseover', showReference);
megaMenuReference.addEventListener('mouseover', showReference);
referenceItem.addEventListener('mouseout', hideReference);
megaMenuReference.addEventListener('mouseout', hideReference);

// ------------------------------------------------------------------------------

function showServices() {
    megaMenuServices.classList.remove("hidden");
}

function hideServices() {
    megaMenuServices.classList.add("hidden");
}

serviceItem.addEventListener('mouseover', showServices);
megaMenuServices.addEventListener('mouseover', showServices);
serviceItem.addEventListener('mouseout', hideServices);
megaMenuServices.addEventListener('mouseout', hideServices);

// --------- TO THE TOP ---------------------------------------------------------------------

const toTop = document.getElementById('tothetop');

toTop.addEventListener('click', () => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
});

window.onscroll = () => {
    const scroll = window.scrollY;
    showScrollTop(scroll);
    hideReference();
    hideServices();
};

function showScrollTop(scroll) {
    // In the case that the scroll is greater than 500 add some classes
    if (scroll > 300) {
        toTop.classList.remove("hidden");
    } else {
        toTop.classList.add("hidden");
    }
}



